import * as React from "react";
import { ProgressIndicatorWrapper, Trough, Fill } from "./progress-indicator-view-style";
import { ChartTitleContainer } from "webapp/ui/smart/charts/chart-legend/chart-legend-style";
import ChartLegend from "webapp/ui/smart/charts/chart-legend/chart-legend";
import type { ProgressProps } from "../progress-indicator-types";

interface Props extends ProgressProps {}

class ProgressIndicatorImpl extends React.PureComponent<Props> {
    public render(): React.ReactNode {
        const { value, minimum, maximum, title, caption } = this.props;

        const progress = Math.round(Math.max(0, Math.min(100, (100 * (value - minimum)) / (maximum - minimum))));

        return (
            <ProgressIndicatorWrapper data-test="app-progress-indicator">
                <ChartTitleContainer isCentered={false}>
                    <div className="chart-title">{title}</div>
                </ChartTitleContainer>
                <Trough>
                    <Fill progress={progress.toString()} />
                </Trough>

                <ChartLegend showDetails={true} caption={caption} />
            </ProgressIndicatorWrapper>
        );
    }
}

const ProgressIndicatorView = ProgressIndicatorImpl;
export default ProgressIndicatorView;
